import { StyleObject } from 'theming/index';

export const root: StyleObject = {
    fontFamily: '"Lato", sans-serif'
};
